// Detects URL -Corjl Demo- and automatically turns it into a link

document.addEventListener('DOMContentLoaded', function() {
  // Only run on product pages
  if (window.location.pathname.includes('/products/')) {
    // Function to convert URLs to clickable links
    function linkifyText() {
      // Find the product description container
      const descriptionContainer = document.querySelector('.t4s-product-info__item.t4s-product__description');
      
      if (!descriptionContainer) return;
      
      // Get all paragraphs in the description
      const paragraphs = descriptionContainer.querySelectorAll('p');
      
      paragraphs.forEach(function(paragraph) {
        // Get the text content
        const originalText = paragraph.textContent;
        
        // Simple URL regex
        const urlRegex = /(https?:\/\/[^\s]+)/g;
        
        // Check if paragraph contains a URL
        if (urlRegex.test(originalText)) {
          // Create a temporary div to work with the HTML
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = paragraph.innerHTML;
          
          // Get all text nodes in the paragraph
          const textNodes = [];
          const walker = document.createTreeWalker(
            tempDiv,
            NodeFilter.SHOW_TEXT,
            null,
            false
          );
          
          let node;
          while (node = walker.nextNode()) {
            textNodes.push(node);
          }
          
          // Process each text node
          textNodes.forEach(function(textNode) {
            const text = textNode.nodeValue;
            if (urlRegex.test(text)) {
              const replacedText = text.replace(urlRegex, function(url) {
                return '<a rel="noopener noreferrer" data-sanitized-target="_blank" href="' + url + '">' + url + '</a>';
              });
              
              // Create a temporary element to hold the new HTML
              const tempEl = document.createElement('div');
              tempEl.innerHTML = replacedText;
              
              // Replace the text node with the new nodes
              const fragment = document.createDocumentFragment();
              while (tempEl.firstChild) {
                fragment.appendChild(tempEl.firstChild);
              }
              
              textNode.parentNode.replaceChild(fragment, textNode);
            }
          });
          
          // Update the original paragraph with our modified content
          paragraph.innerHTML = tempDiv.innerHTML;
        }
      });
      
      // Double-check all links to ensure they have target="_blank"
      const allLinks = descriptionContainer.querySelectorAll('a');
      allLinks.forEach(function(link) {
        // Check if the link is a URL (not an internal link)
        if (link.href.startsWith('http')) {
          link.setAttribute('target', '_blank');
          link.setAttribute('rel', 'noopener noreferrer');
        }
      });
    }
    
    // Run the linkify function
    linkifyText();
    
    // Also run it after a short delay to ensure all content is loaded
    setTimeout(linkifyText, 1000);
  }
});
